import { render, staticRenderFns } from "./ChatFilterComponent.vue?vue&type=template&id=c5c12476&scoped=true"
import script from "./ChatFilterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatFilterComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ChatFilterComponent.vue?vue&type=style&index=0&id=c5c12476&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c12476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5c12476')) {
      api.createRecord('c5c12476', component.options)
    } else {
      api.reload('c5c12476', component.options)
    }
    module.hot.accept("./ChatFilterComponent.vue?vue&type=template&id=c5c12476&scoped=true", function () {
      api.rerender('c5c12476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ChatFilterComponent.vue"
export default component.exports